import { convertOptionsToMap } from '../../utilities';

export const statuses = [
  { value: 'pending', label: 'Pending' },
  { value: 'failed', label: 'Failed' },
  { value: 'completed', label: 'Completed' },
];

export const statusesMap = convertOptionsToMap(statuses);
